/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-19 14:42:59
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-03-26 18:17:56
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelEditorProductSearch/Preview/index.tsx
 */
import React from 'react';

import PreviewContainer from '@/src/constrains/SalesChannelPreviewPageComponents/PreviewContainer';
import {
  // CheckoutTabBars,
  FeatureProduct,
  HotTags,
  SearchBar,
} from 'unifyxp-ecomm-components';

import styles from './style.module.less';

import { useSelector } from 'react-redux';
import { withDraggableId } from 'src/constrains/Preview/util';
import { EnumCollapseId, getContent, onCollapseOpen } from '../slice';
const _SearchBar = withDraggableId(
  SearchBar,
  EnumCollapseId.searchBar,
  onCollapseOpen,
);
const _FeaturedProducts = withDraggableId(
  FeatureProduct,
  EnumCollapseId.featuredProducts,
  onCollapseOpen,
);
const _HotTags = withDraggableId(
  HotTags,
  EnumCollapseId.hotTags,
  onCollapseOpen,
);
function Preview(props) {
  const { wrapperClassName } = props;
  const _data: any = useSelector(getContent());
  const { enabled, featuredProducts = {}, searchBar, hotTags } = _data;
  const { items, title } = hotTags;
  const { placeholder } = searchBar;

  return (
    <PreviewContainer
      className={styles.container}
      wrapperClassName={wrapperClassName}>
      {enabled ? (
        <React.Fragment>
          <div className={styles.searchBar}>
            <_SearchBar
              onSearch={(e) => {
                console.log(e);
              }}
              onCancel={() => {
                console.log(123);
              }}
              placeholder={placeholder}
            />
          </div>
          {title && (
            <div className={styles.hotTags}>
              {' '}
              <_HotTags title={title} items={items} />
            </div>
          )}
          {(featuredProducts || {}).enabled && (
            <_FeaturedProducts
              title={(featuredProducts || {}).title}
              titleColor={(featuredProducts || {}).titleTextColor}
              products={((featuredProducts || {}).products || []).map((i) => {
                return {
                  ...i,
                  productSetPriceSettings: {
                    currency: 'HKD',
                    setPrice: '100.00',
                  },
                  formattedSecondaryPrice: 'AUD 100.00',
                  children: null,
                };
              })}
              style={{ backgroundColor: '#ffffff' }}
            />
          )}
        </React.Fragment>
      ) : null}
    </PreviewContainer>
  );
}

export default Preview;
